/*
Project : https://www.freespirit.com.sg/
Name 	: Custom Javascript and jquery
*/


jQuery(document).ready(function(){
  jQuery('.shopify-payment-button__button').on('click', function(event) {
        // Get the value of the delivery date input
        var deliveryDate = jQuery('.inputWithButton.datePicker').val();

        // Check if the delivery date is empty
        if (!deliveryDate) {
            event.preventDefault(); // Prevent the default button click behavior

            // Optionally, show a message to the user

            // Get the product ID and variant ID from the data attributes
            var productId = jQuery(this).data('product-id');
            var variantId = jQuery(this).data('variant-id');

            // Send an Ajax request to add the product to the cart
            jQuery.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'json',
                data: {
                    id: variantId,
                    quantity: 1
                },
                success: function(response) {
                    // Handle the response
                    console.log(response);

                    // Redirect to the cart page
                    window.location.href = '/cart';
                },
                error: function(error) {
                    console.log(error);
                }
            });
        }
    });
  
//29-01-2022
      jQuery('.single-option-selector').on('change', function(){
        var selectedOptionText = $(this).children(':selected').attr('data-id');
        console.log(selectedOptionText);
             jQuery(this).closest('.one-third').find('.thumbnail__price .money').text(selectedOptionText);
        });
   
  
  //======================= Quantity Increment and decrement =========================== // 



	jQuery('.product-container-wrap .plus-cart').click(function (e) {
	
     
      
      
		field_name = jQuery(this).attr('field');
      
		var val = parseInt(jQuery('input[id=' + field_name + ']').val());
      
        var max = parseInt(jQuery('input[id=' + field_name + ']').attr('max'));
      
        var min = parseInt(jQuery('input[id=' + field_name + ']').attr('min'));
      
        var step = parseInt(jQuery('input[id=' + field_name + ']').attr('step'));

		if ( max && ( max <= val ) ) {
         
          
          jQuery('input[id=' + field_name + ']').val(max);
          
         
          
          
        } else {
          
          jQuery('input[id=' + field_name + ']').val(val+step);
        
          
          
        }

		
	});

	jQuery('.product-container-wrap .minus-cart').click(function (e) {
      

      
	   field_name = jQuery(this).attr('field');
      
		var val = parseInt(jQuery('input[id=' + field_name + ']').val());
      
        var max = parseInt(jQuery('input[id=' + field_name + ']').attr('max'));
      
        var min = parseInt(jQuery('input[id=' + field_name + ']').attr('min'));
      
        var step = parseInt(jQuery('input[id=' + field_name + ']').attr('step'));


		 if ( min && ( min >= val ) ) {
           
            jQuery('input[id=' + field_name + ']').val(min);
         
           
         } else if ( val > 1 ) {
           
            jQuery('input[id=' + field_name + ']').val(val-step);
          	
         }
      
	}); 
  jQuery(document).ready(function() {
    jQuery('.shopify-payment-button__button').on('click', function(event) {
        // Get the value of the delivery date input
        var deliveryDate = $('.inputWithButton.datePicker').val();

        // Check if the delivery date is empty
        if (!deliveryDate) {
            event.preventDefault(); // Prevent the default button click behavior

            // Optionally, show a message to the user

            // Redirect to the cart page
            window.location.href = '/cart';
        }
    });
});
  
 });

	
